import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const addToSupplierEmails = createApi(`AddToSupplierEmailsSlice`, "POST");

const AddToSupplierEmailsSlice = createSlice({
  name: 'AddToSupplierEmailsSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addToSupplierEmails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToSupplierEmails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addToSupplierEmails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default AddToSupplierEmailsSlice.reducer;
